export const TITLES = ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof"];

export const TITLES_OPTIONS = TITLES.map((item) => ({
    label: item,
    value: item,
}));
